import React, { memo, useContext, useState } from 'react';
import { AppContext } from 'App';

import './busninessConnection.scss';

const BusninessConnection = () => {
  const { pageData } = useContext(AppContext);
  const [expanded, setExpanded] = useState(false);
  // const [indexValue, setIndexValue] = useState(0);
  const [visibleItems, setVisibleItems] = useState(1);
  const expandedHandler = () => {
    // if (!expanded) {
    //   setIndexValue(pageData?.communication?.length);
    // } else {
    //   setIndexValue(0);
    // }
    // setExpanded(!expanded);

    if (!expanded) {
      setVisibleItems(pageData?.communication?.length);
    } else {
      setVisibleItems(1);
    }
    setExpanded(!expanded); 
  };
  return (
    <section className="business_section">
      <div className="container">
        {pageData?.communication
          // .filter((_, pIndex) => pIndex <= indexValue)
          .map((itemData, index) => {
            const { title, title3, paragraph } = itemData;
            return (
              <div key={index} className={`business_content ${index < visibleItems ? 'show' : 'hide'}`}>
                {title && <h2>{title}</h2>}
                {title3 && <h3>{title3}</h3>}
                {paragraph?.map((paragraphData, i) => (
                  <p key={i}>{paragraphData}</p>
                ))}
                {itemData?.subItems?.map((subData, i) => (
                  <div className="sub_content">
                    {subData.subTitle && (
                      <div className="sub_title">
                        <strong>{subData.subTitle}</strong>
                      </div>
                    )}
                    {subData.subHeading && <h3>{subData.subHeading}</h3>}
                    <p>{subData.paragraph}</p>
                  </div>
                ))}
              </div>
            );
          })}
        <div className="view_wrapper">
          <span className="pointer_view" onClick={() => expandedHandler()}>
            {expanded ? 'Read Less' : 'Read More'}
          </span>
        </div>
      </div>
    </section>
  );
};

export default memo(BusninessConnection);
